<template>
  <section class="out-of-office-message" v-if="showOutOfOffice">
    {{ $t('NARR.OUT_OF_OFFICE.FUNCTIONBOX_ACTIVE')}} <b-button v-if="showDeactivate" size="sm" class="no-border ml-2" @click="Deactivate">{{ $t('DEACTIVATE') }}</b-button>
  </section>
</template>
<script>
import { DateTime } from "luxon";
export default {
  props: ["functionbox_uuid"],
  data() {
    return {
    };
  },
  methods: {
    async Deactivate(){
      try {
        await this.$http.post(`${this.user.hostname}/administration/functionbox/out-of-office`,{
            account_id: 0,
            out_of_office_enabled: false,
            functionbox_uuid: this.functionbox_uuid
        });
        this.$noty.info(this.$t('DEACTIVATED'));
        await this.$store.dispatch("user/fetchUser");
      // eslint-disable-next-line no-empty
      } catch {}
    }
  },
  computed: {    
    CurrentFunctionbox(){
      let functionbox_uuid = this.functionbox_uuid;
      if(this.functionbox_uuid == ""){
        return null;
      }else{
        return this.user.functionboxes.items.find(item => item.functionbox_uuid === functionbox_uuid);
      }
    },
    showDeactivate(){
      return this.user.information.is_admin > 0 || this.CurrentFunctionbox.is_admin == 1;
    },
    showOutOfOffice(){
      if(!this.CurrentFunctionbox)
      {
        return false;
      }
      let start = DateTime.fromISO(this.CurrentFunctionbox.out_of_office_start_date, { zone: "utc" });
      let end = DateTime.fromISO(this.CurrentFunctionbox.out_of_office_end_date, { zone: "utc" });
      let now = new DateTime.local().toUTC();
      if(this.CurrentFunctionbox.out_of_office_date != undefined)
      {
        if(this.CurrentFunctionbox.out_of_office_enabled && !this.CurrentFunctionbox.out_of_office_date)
        {
          return true;
        }
        if(this.CurrentFunctionbox.out_of_office_enabled && this.CurrentFunctionbox.out_of_office_date && start < now && now < end){
          return true;
        }
      }else{
        return this.CurrentFunctionbox.out_of_office_enabled;
      }
      return false;
    }
  },
  mounted: function() {   
  },
};
</script>
<style></style>